/*
 * LoginPage.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Feb 02 2023 mys Company
 */

import { useLogin } from '../hook/useAccountHooks'
import bg01 from '../../../assets/images/bg-01.jpg'
import { localization } from '../../../config/localize/localizable'
import DoneButton from '../../../component/element/DoneButton'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FormikTextField from '../../../component/element/FormikTextField'
import * as constants from '../../../config/constant/constants'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-hot-toast'

const LoginPage = () => {
    //
    //  MARK: VARIIABLE

    const Login = useLogin()
    const navigate = useNavigate()

    const validationSchema = Yup.object().shape({
        userName: Yup.string().required(localization.MSG_username_isrequired).min(8, localization.MSG_mincharacter).max(70, localization.MSG_maxcharacter),
        password: Yup.string().required(localization.MSG_password_isrequired).min(8, localization.MSG_mincharacter).max(70, localization.MSG_maxcharacter),
    })

    const formik = useFormik({
        initialValues: {
            userName: '',
            password: '',
        },
        validationSchema,
        // validateOnChange: false,
        validateOnBlur: true,
        onSubmit: (values) => {
            handleClick(values)
        },
    })

    //
    //  MARK: METHOD
    const handleClick = async (model) => {
        await Login.loginService(
            {
                username: model.userName,
                password: model.password,
                type: 'EMAIL',
                moduleType: 'WEB',
            },
            {
                onSuccess: async (result) => {
                    constants.setUserId(result.data.userId)
                    constants.setToken(result.data.token)
                    constants.setServerDate(result.data.date)
                    constants.setIsExpert(result.data.expert)
                    constants.setMenus(JSON.stringify(result.data.menus))
                    constants.setPermissions(JSON.stringify(result.data.permissions))
                    navigate('/adminpanel/dashboard', { replace: true })
                },
                onError: async (response) => {
                    debugger
                    toast.error(response.code === 'ERR_NETWORK' ? localization.error_connectionfailed : response.error)
                },
            }
        )
    }

    return (
        <div
            className="w-full h-screen bg-no-repeat bg-cover bg-fixed fixed mb-4 select-none"
            style={{
                backgroundImage: 'url(' + bg01 + ')',
            }}
        >
            <form className="bg-white w-5/6 md:w-2/3 lg:w-1/3  h-6/7 p-10 m-auto my-8  rounded">
                <h1 className="text-center font-bold text-lg mb-3">{localization.adminpanel + ' ' + localization.productname}</h1>

                <div className="form-group mb-3">
                    <FormikTextField name="userName" formik={formik} label={localization.username} placeHolder={localization.username} />
                </div>

                <div className="form-group mb-3">
                    <FormikTextField name="password" inputType="password" formik={formik} label={localization.password} placeHolder={localization.password} />
                </div>

                <div className="form-group mb-3 mt-4">
                    <DoneButton type="button" buttonClassName="bg-purple-500" label={localization.ok} onClick={formik.handleSubmit} />
                </div>
            </form>
        </div>
    )
}

export default LoginPage
